// Tamaño de pantalla para el diseño. En el celular nada cambia; desde 1024 px (tablet horizontal o notebook) algunas
// pantallas suman una columna, como el mapa al lado de la lista de paradas.
import { useSyncExternalStore } from 'react';

/** El mismo punto de corte que `lg:` de Tailwind. */
const ANCHA = '(min-width: 1024px)';

const hayMedia = () => typeof window !== 'undefined' && typeof window.matchMedia === 'function';

function suscribir(avisar: () => void): () => void {
  if (!hayMedia()) return () => {};
  const m = window.matchMedia(ANCHA);
  m.addEventListener('change', avisar);
  return () => m.removeEventListener('change', avisar);
}

const leer = () => hayMedia() && window.matchMedia(ANCHA).matches;

/**
 * true en pantallas de 1024 px o más. Sirve para montar solo ahí lo que pesa (el mapa embebido), así el celular no
 * lo descarga.
 */
export function usePantallaAncha(): boolean {
  return useSyncExternalStore(suscribir, leer, () => false);
}
